var $63eb283d27decb4d$exports = {};
"use strict";
// Navigation- Mobile
const $63eb283d27decb4d$var$navBtn = document.querySelector(".menuicon");
const $63eb283d27decb4d$var$menuIcon = document.querySelector(".menuicon");
const $63eb283d27decb4d$var$mobileNav = document.querySelector(".mobile-nav");
const $63eb283d27decb4d$var$mobileNavList = document.querySelector(".mobile-nav-list");
const $63eb283d27decb4d$var$headerDoc = document.querySelector(".header");
// State
let $63eb283d27decb4d$var$state = "closed";
$63eb283d27decb4d$var$navBtn.addEventListener("click", function() {
    if ($63eb283d27decb4d$var$state === "closed") {
        $63eb283d27decb4d$var$headerDoc.style.height = "25rem";
        $63eb283d27decb4d$var$headerDoc.classList.toggle("header-mob");
        $63eb283d27decb4d$var$menuIcon.classList.toggle("menuicon-open");
        setTimeout(function() {
            $63eb283d27decb4d$var$mobileNav.style.display = "flex";
            $63eb283d27decb4d$var$mobileNavList.style.display = "flex";
        }, 600);
        $63eb283d27decb4d$var$state = "open";
    } else if ($63eb283d27decb4d$var$state === "open") {
        $63eb283d27decb4d$var$headerDoc.classList.toggle("header-mob");
        $63eb283d27decb4d$var$menuIcon.classList.toggle("menuicon-open");
        $63eb283d27decb4d$var$mobileNav.style.display = "none";
        $63eb283d27decb4d$var$mobileNavList.style.display = "none";
        setTimeout(function() {
            $63eb283d27decb4d$var$headerDoc.style.height = "9.6rem";
        }, 200);
        $63eb283d27decb4d$var$state = "closed";
    }
});
//////////////////////////////////////////
// Smooth Scrolling
/////////////////////////////////////////
const $63eb283d27decb4d$var$eventList = function(elname, secName) {
    const el = document.querySelectorAll(`${elname}`);
    const section = document.getElementById(secName);
    el.forEach((elem)=>elem.addEventListener("click", function() {
            console.log(section);
            section.scrollIntoView({
                behavior: "smooth"
            });
        }));
};
$63eb283d27decb4d$var$eventList(".about", "how");
$63eb283d27decb4d$var$eventList(".services", "how");
$63eb283d27decb4d$var$eventList(".testimonials", "how");
$63eb283d27decb4d$var$eventList(".plans", "how");
$63eb283d27decb4d$var$eventList(".contact", "how"); // imports
 // import "../node_modules/core-js/stable";
 // import "regenerator-runtime/runtime";


//# sourceMappingURL=index.d6c55c15.js.map
